// extracted by mini-css-extract-plugin
export default {"timeMapping":"TimeMapping_timeMapping__j+HqM","break":"TimeMapping_break__2E-Gu"};